import styled from 'styled-components';

import mq from '@/utils/media-queries';

const Row = styled.div`
  display: flex;
  flex-wrap: nowrap;

  ${mq.mobile(css`
    flex-wrap: wrap;
  `)};
`;

export default Row;



// WEBPACK FOOTER //
// ./src/components/Row.js